export default __webpack_public_path__ + "static/media/impacto-social.04086d3e.png";